import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Broker, Platform } from '@c4/core';
import { AuthenticationService } from '@c4/auth';

import { SysmanComponentBase, IOnBrokerConnectedInit } from '../sysman/sysman.component';
import { ConnectedDeviceService, VersionsService, ProcessService } from '../services';

@Component({
  selector: 'sysman-process-status',
  templateUrl: './sysman-process-status.component.html',
  styleUrls: ['./sysman-process-status.component.less']
})
export class SysmanProcessStatusComponent extends SysmanComponentBase implements OnInit, IOnBrokerConnectedInit {

  allServices: Array<any>;
  allVersions: string;
  errorMsg: string;
  showConfirmDirectorChange: boolean = false;
  directorStatus: string = "";

  private processDescriptions: {[index:string]: any} = require('!json-loader!../assets/data/process-descriptions.json');

  constructor(
    private store: Store<any>,
    private router: Router,
    private route: ActivatedRoute,
    private broker: Broker,
    private platform: Platform,
    private connectedDeviceService: ConnectedDeviceService,
    private versionsService: VersionsService,
    private processService: ProcessService,
    private auth: AuthenticationService
  ) {

    super(router, route, store, broker, platform, connectedDeviceService, versionsService);
    super.setBrokerInit(this.onBrokerConnectedInit); // method to call on broker init

    this.allServices = [];
    this.allVersions = "";
    this.errorMsg = "";
    this.showConfirmDirectorChange = false;

    this.store.select(s => s.versions).subscribe(
      v => {
        console.log('in ngOnInit versions', v);
        if (v) {
          this.allVersions = v.versions.versions;
          if (this.allServices.length > 0)
            this.attachVersionsToServices();
        }
      });
  }

  ngOnInit() {
    super.OnInit();
  }

  ngOnDestroy() {
    super.destroy();
  }

  onBrokerConnectedInit() {
    this.getServices();
    this.connDevice.take(1).subscribe(conn => {
      this.versionsService.getAllVersions(conn.connectedDevice.address);
    });
  }

  getServices() {
    this.connectedDeviceService.setWorking(true);
    this.connDevice.take(1).subscribe(conn => {
      this.processService.getProcessStatus((conn.connectedDevice.address && (conn.connectedDevice.address != this.brokerHost)) ? conn.connectedDevice.address : null).then(
        (data: any) => {
          this.connectedDeviceService.setWorking(false);
          console.log('in getServices()', data);
          var services = [];
          for (var key in data) {
            // don't show zap and zserver2
            if ((key != "zap") && (key != "zserver2"))
              services.push({ "name": key, "status": data[key], "version": "" });
          }
          this.allServices = services;
          if (this.allVersions != "")
            this.attachVersionsToServices();
        },
        (err: any) => {
          this.connectedDeviceService.setWorking(false);
          console.error('getServices() error: ', err);
        });
    });
  }
  
  saveDirectorChange() {
    this.toggleService({name: "director", status: this.directorStatus, version: ""});
  }

  toggleService(service: {
      name: string;
      status: string;
      version: string}) {

    this.connDevice.take(1).subscribe(conn => {

      // show confirmation modal when changing director
      if ((service.name == 'director') && (conn.connectedDevice.address == this.brokerHost)) {
        if (this.showConfirmDirectorChange) // take down the modal
          this.showConfirmDirectorChange = false;
        else { // show the modal confirm
          this.showConfirmDirectorChange = true;
          this.directorStatus = service.status;
          return;
        }
      }

      this.connectedDeviceService.setWorking(true);
      this.processService.toggleProcessStatus(service.name, service.status,
        ((conn.connectedDevice.address != this.brokerHost) ? conn.connectedDevice.address : null)).then(
        (result: any) => {
          if (result.result && (result.result.indexOf("Disabled " + service.name) > -1)) {
            service.status = "disabled";
            this.getServices();
          }
          else
            if (result.result && (result.result.indexOf("Enabled " + service.name) > -1)) {
              service.status = "enabled";
              this.getServices();
            }
            else {
              this.errorMsg = result.result;
              this.connectedDeviceService.setWorking(false);
            }

          // only route back to dashboard if changing director status on the broker host controller
          if ((service.name == 'director') && (conn.connectedDevice.address == this.brokerHost)) {
            this.directorStatus = "";
            // display modal for 5 seconds then go back to dashboard
            setTimeout(o => {
                this.router.navigate(['/']);
            }, 5000);
          }
        },
        (err: any) => {
          console.error('toggleService() error: ', err);
          this.connectedDeviceService.setWorking(false);
        });
    }); 
  }

  // add version info for each process
  private attachVersionsToServices() {

    // make array of all service names
    var allServiceNames: Array<string> = [];
    this.allServices.map(s => {
      allServiceNames.push(s.name);
    });
    // get all versions of services
    let serviceVersions: string[] = this.versionsService.getVersions(allServiceNames, this.allVersions);
    let services = this.allServices;
    serviceVersions.forEach((version, index) => {
      services[index].version = version;
    });
    this.allServices = services;
  }


}


// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/sysman-process-status/sysman-process-status.component.ts